import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, FadeUp } from "@/components/invite/Reveal";
import { mediaUrl } from "@/lib/media";

// El día de la semana sale de la fecha de la boda. Estaba escrito "sábado" y
// seguía diciéndolo después de cambiar la fecha a un domingo.
const diaSemana = (iso) => {
  const d = new Date(iso);
  return Number.isNaN(d.getTime())
    ? ""
    : d.toLocaleDateString("es-ES", { weekday: "long" });
};

const VENUE_FALLBACK =
  "https://images.unsplash.com/photo-1712314947761-a8d718bd8c32?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwdmVudWUlMjBlbGVnYW50JTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4MjcwMjg4MHww&ixlib=rb-4.1.0&q=85";

const VenueBlock = ({ place, testid, delay }) => (
  <FadeUp delay={delay} className="border-t border-nude pt-8">
    <p className="overline-label text-bronze">{place.title}</p>
    <h3 className="font-serif text-3xl sm:text-4xl font-light text-ink mt-4 tracking-tight">
      {place.venue}
    </h3>
    <p className="mt-3 text-sm text-taupe leading-relaxed">{place.address}</p>
    <a
      href={place.maps_url}
      target="_blank"
      rel="noopener noreferrer"
      className="group mt-4 inline-flex min-h-[44px] items-center gap-2 py-2 text-xs uppercase tracking-[0.28em] text-olive underline-offset-4 hover:underline"
      data-testid={testid}
    >
      Abrir en Google Maps
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={1.5} />
    </a>
  </FadeUp>
);

export default function LocationSection({ wedding, content }) {
  return (
    <section className="bg-cream px-6 sm:px-12 py-24 sm:py-32" data-testid="location-section">
      <div className="mx-auto grid max-w-6xl grid-cols-1 md:grid-cols-12 gap-10 md:gap-14">
        <FadeUp className="md:col-span-5">
          <div className="relative">
            <motion.img
              src={mediaUrl(content?.photos?.venue, VENUE_FALLBACK)}
              alt="Lugar de la celebración"
              className="aspect-[3/4] w-full object-cover border border-nude"
              whileHover={{ scale: 0.985 }}
              transition={{ duration: 0.6 }}
              data-testid="venue-image"
            />
            <span className="absolute -bottom-5 -left-5 hidden md:block h-24 w-24 border border-bronze" aria-hidden="true" />
          </div>
        </FadeUp>
        <div className="md:col-span-6 md:col-start-7 flex flex-col justify-center gap-12">
          <Reveal>
            <h2 className="font-serif text-4xl sm:text-5xl font-light tracking-tight text-ink">
              Os esperamos el <span className="italic text-olive">{diaSemana(wedding.date_iso)}</span>
            </h2>
          </Reveal>
          <FadeUp delay={0.1}>
            <p className="font-serif text-2xl text-ink">{wedding.date_label}</p>
            <p className="overline-label text-bronze mt-2">a las {wedding.time_label}</p>
          </FadeUp>
          <VenueBlock place={wedding.ceremony} testid="ceremony-maps-link" delay={0.15} />
          <VenueBlock place={wedding.celebration} testid="celebration-maps-link" delay={0.25} />
        </div>
      </div>
    </section>
  );
}
